export default "__VITE_ASSET__BcgWrx7E__"